'use strict';

var util = require('../util/property-util');

module.exports = /*@ngInject*/ ["ProjectService", function FilterStorage(ProjectService) {

    var storage = {
        map: new Map(),
        get: get,
        put: put,
        putAll: putAll,
        deleteKey: removeKey,
        deleteAll: removeAll,
        has: has,
        clear: clear
    };

    ProjectService.subscribe('filter-storage', function () {
        storage.map = retrieve();
    });

    /**
     * Put key,value for the correct filter. Identified by 'name'.
     *
     * @param name
     * @param key
     * @param value
     * @param triggerStorage save to localStorage or not.
     * @returns {boolean}
     */
    function put(name, key, value, triggerStorage) {

        if (!util.isDefined(triggerStorage)) {
            triggerStorage = true;
        }

        if (util.isDefined(name) && util.isDefined(key) && util.isDefined(value)) {

            var filter = storage.map.get(name);

            if (!util.isDefined(filter)) {
                filter = new Map();
                storage.map.set(name, filter);
            }

            filter.set(key, value);

            if (triggerStorage) store();

            return true;
        } else {
            if (!util.isDefined(key)) console.error("Unable to store filter param. empty key");
            if (!util.isDefined(name)) console.error("Unable to store filter param. empty filter name");
            return false;
        }
    }

    function putAll(name, object) {
        for (var prop in object) {
            if (object.hasOwnProperty(prop)) {
                put(name, prop, object[prop], false);
            }
        }

        //ignore key value so that we retrieve all objects for filter with specified name.
        store();
        return get(name);
    }

    /**
     * Get value from the correct filter, named 'name'.
     *
     * @param name
     * @param key
     * @returns {*}
     */
    function get(name, key) {

        var filter = undefined;

        if (util.isDefined(name) && !util.isDefined(key)) {
            filter = storage.map.has(name) ? storage.map.get(name) : undefined;
            if (filter instanceof Map) {
                filter = asKeyValue(filter);
            }
            return util.isDefined(filter) ? filter : undefined;
        }

        if (util.isDefined(name) && util.isDefined(key)) {
            filter = storage.map.get(name);
            filter = util.isDefined(filter) && filter.has(key) ? filter.get(key) : undefined;
            if (filter instanceof Map) {
                filter = asKeyValue(filter);
            }
            return filter;

        }

        if (!util.isDefined(name)) console.error("Unable to store filter param. empty name");
        return undefined;
    }

    /**
     * Verifies if filter, identified by name, has specified 'key'.
     *
     * @param name
     * @param key
     * @returns {boolean}
     */
    function has(name, key) {
        return util.isDefined(get(name, key));
    }

    /**
     * Removes key entry in filter, identfied by name.
     *
     * @param name
     * @param key
     * @returns {boolean} if successful removal.
     */
    function removeKey(name, key) {

        if (util.isDefined(name) && util.isDefined(key)) {
            var filter = storage.map.get(name);
            return util.isDefined(filter) && filter.has(key) ? filter.delete(key) : true;
        } else {
            if (!util.isDefined(key)) console.error("Unable to store filter param. empty key");
            if (!util.isDefined(name)) console.error("Unable to store filter param. empty filter name");
            return false;
        }
    }

    /**
     * Removes filter, identified by name.
     *
     * @param name
     * @returns {boolean} if successful removal.
     */
    function removeAll(name) {
        if (util.isDefined(name)) {
            return storage.map.has(name) ? storage.map.delete(name) : true;
        }
        console.error("Unable to remove filter param. empty filter name");
        return false;
    }

    function asKeyValue(filterAsMap) {
        var object = {};

        filterAsMap.forEach(function (value, key) {
            object[key] = value;
        });

        return object;
    }

    function asObject(filterAsMap) {
        var object = {};

        filterAsMap.forEach(function (value, key) {
            if (value instanceof Map) {
                object[key] = asKeyValue(value);
            } else {
                object[key] = value;
            }
        });

        return object;
    }

    function asMap(filterAsObject) {
        var map = new Map();

        for (var property in filterAsObject) {
            if (filterAsObject.hasOwnProperty(property)) {
                var subMap = new Map();
                var subObject = filterAsObject[property];

                for (var subProperty in subObject) {
                    if (subObject.hasOwnProperty(subProperty)) {
                        subMap.set(subProperty, subObject[subProperty]);
                    }
                }

                map.set(property, subMap);
            }
        }
        return map;
    }

    function store() {
        if (getProjectFilter()) {
            localStorage.setItem(getProjectFilter(), JSON.stringify(asObject(storage.map)));
        }
    }

    function clear() {
        if (getProjectFilter()) {
            localStorage.removeItem(getProjectFilter());
        }
    }

    function retrieve() {
        var result = new Map();
        try {
            if (getProjectFilter()) {
                var parsed = JSON.parse(localStorage.getItem(getProjectFilter()));
                if (util.isDefined(parsed)) {
                    result = asMap(parsed);
                }
            }
        } catch (e) {
            console.error("Failed to retrieve noc filter from storage. resetting...");
            localStorage.removeItem("noc-filter");
        }
        return result;
    }


    function getProjectFilter() {
        if (ProjectService.getSelectedProjectId()==undefined || ProjectService.getSelectedProjectId()==null || ProjectService.getSelectedProjectId=="") {
            return null;
        }
        return 'noc-filter-' + ProjectService.getSelectedProjectId();
    }

    return storage;
}];